import * as _ from 'lodash';
import * as moment from 'moment';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from './utility-functions';
import staff from '../authentication/signup/signup.staff.model';
import { timingSafeEqual } from 'crypto';
import { TreeModule } from 'primeng/primeng';

export class BlockSlots {
	private utilityFunctions = new UtilityFunctions();
	private blockSlotColumnName = [];
	constructor() {

	}
	readBlockSlotFile(event) {
		let lines: any;
		const that = this;
		let validateLog = [];
		let logList = [];
		let blockingList = [];
		var file = event.target.files[0];
		let logObj;
		return new Promise((resolve) => {
			let reader = new FileReader();
			reader.onload = function () {
				let text = reader.result;
				lines = text.split(/\r?\n/);
				let headers = lines[0].split(',');
				headers = headers.filter(function (entry) { return entry.trim() != ''; });
				_.remove(lines, function (record: string) {
					return record.includes(',,,,,,,,');
				});
				if (lines && lines.length > 0) {
					lines.forEach(function (line, i) {
						if (line !== '' && line !== ',,,,,,,,,') {
							if (i == 0) {
								that.blockSlotColumnName = line.split(',');
							} else {
								validateLog = [];
								let lineObj = line.split(',');
								let obj = that.createBlockSlotObj(lineObj);
								if (obj) {
									let blockObj = that.validateMandatoryFieldsForBlocking(obj, validateLog);
									if (blockObj.validateLog.length <= 0) {
										blockingList.push(blockObj.obj);
									} else {
										logObj = {
											'obj': blockObj.obj,
											'logList': blockObj.validateLog
										}
										logList.push(logObj);
									}
								}

								if (i <= (lines.length - 1)) {
									resolve({ blockingList: blockingList, loglList: logList, message: '' });
								}
							}
						} else {
							resolve({});
						}
					});
				}
			};
			reader.readAsText(file);
		});
	}

	validateMandatoryFieldsForBlocking(blockObj: any, validateLog: Array<any>): any {
		let dateFormat = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
		let regex = /^[0-9]*$/;
		if (blockObj.facilityName && !this.utilityFunctions.validateFacilityName(blockObj.facilityName)) {
			validateLog.push(CONSTANT_VALUES.LOG.InValidFacilityName);
		}

		if (blockObj.startDate && !dateFormat.test(blockObj.startDate) || blockObj.endDate && !dateFormat.test(blockObj.endDate)) {
			validateLog.push('Invalid date format');
		}
		else if (blockObj.startDate && blockObj.endDate && blockObj.startTime && blockObj.endTime) {
			blockObj.endTime = blockObj.endTime == '24:00' ? '23:59' : blockObj.endTime;
			let blockingStartDateStartTime = (blockObj.startDate + ' ' + blockObj.startTime).toString();
			let blockingStartDateEndTime = (blockObj.startDate + ' ' + blockObj.endTime).toString();

			let blockingEndDateStartTime = (blockObj.endDate + ' ' + blockObj.startTime).toString();
			let blockingEndDateEndTime = (blockObj.endDate + ' ' + blockObj.endTime).toString();

			let validFlagForBookingStartDateStartTime = new Date(blockingStartDateStartTime);
			let validFlagForBookingStartDateEndTime = new Date(blockingStartDateEndTime);

			let validFlagForBookingEndDateStartTime = new Date(blockingEndDateStartTime);
			let validFlagForBookingEndDateEndTime = new Date(blockingEndDateEndTime);

			if (!validFlagForBookingStartDateStartTime || validFlagForBookingStartDateStartTime.toString() == 'Invalid Date') {
				validateLog.push('Invalid Start Date or time');
			} else if (!validFlagForBookingStartDateEndTime || validFlagForBookingStartDateEndTime.toString() == 'Invalid Date') {
				validateLog.push('Invalid Start Date or time');
			} else {
				blockObj.startDateEndTime = this.utilityFunctions.maketimeZoneOfsetDate(validFlagForBookingStartDateEndTime, true);
				blockObj.startDateStartTime = this.utilityFunctions.maketimeZoneOfsetDate(validFlagForBookingStartDateStartTime, true);
			}

			if (!validFlagForBookingEndDateStartTime || validFlagForBookingEndDateStartTime.toString() == 'Invalid Date') {
				validateLog.push('Invalid End Date or time');
			} else if (!validFlagForBookingEndDateEndTime || validFlagForBookingEndDateEndTime.toString() == 'Invalid Date') {
				validateLog.push('Invalid End Date or time');
			} else {
				blockObj.endDateEndTime = this.utilityFunctions.maketimeZoneOfsetDate(validFlagForBookingEndDateEndTime, true);
				blockObj.endDateStartTime = this.utilityFunctions.maketimeZoneOfsetDate(validFlagForBookingEndDateStartTime, true);
			}
		}
		if (blockObj.repeatCount && !regex.test(blockObj.repeatCount)) {
			validateLog.push('No of Times field should be number');
		}

		if (blockObj.isEntireDay && (blockObj.isEntireDay.toLowerCase() != 'yes' && blockObj.isEntireDay.toLowerCase() != 'no')) {
			validateLog.push('value of filed Entire Day should be yes or no');
		}
		let blockingObj = {
			validateLog: validateLog,
			obj: blockObj
		}
		return blockingObj;
	}

	createBlockSlotObj(record: Array<any>) {
		let obj = {
			facilityName: '',
			unitName: '',
			startDate: '',
			endDate: '',
			isEntireDay: '',
			startTime: '',
			endTime: '',
			repeatCount: '',
			category: ''
		};
		if (record && record.length > 0) {
			for (let i = 0; i < record.length; i++) {
				switch (this.blockSlotColumnName[i]) {
					case 'Activity':
						obj.facilityName = record[i] ? record[i] : '';
						break;
					case 'Category':
						obj.category = record[i] ? record[i] : '';
						break;
					case 'Start Date':
						obj.startDate = record[i] ? record[i] : '';
						break;
					case 'End Date':
						obj.endDate = record[i] ? record[i] : '';
						break;
					case 'Start Time':
						obj.startTime = record[i] ? record[i] : '';
						break;
					case 'End Time':
						obj.endTime = record[i] ? record[i] : '';
						break;
					case 'Unit Name':
						obj.unitName = record[i] ? record[i] : '';
						break;
					case 'Entire Day':
						obj.isEntireDay = record[i] ? record[i] : '';
						break;
					case 'No of Times':
						obj.repeatCount = record[i] ? record[i] : '';
						break;

				}
			}
		}
		if (obj.facilityName && obj.category && obj.startDate && obj.endDate && obj.unitName) {
			return obj;
		} else {
			return null;
		}

	}

	calculateBlockSlots(blockList: Array<any>, vendorId: string): any {
		const facilityList = this.getFacilityList();
		const that = this;
		let facilityInfo;
		let holidays = [];
		let facilityData: Array<any> = [];
		if (blockList.length > 0 && facilityList.length > 0) {
			blockList.forEach(blockObj => {
				blockObj.isEntireDay = blockObj.isEntireDay.toLowerCase() == 'yes' ? true : false;
				blockObj.repeatCount = !blockObj.repeatCount || (blockObj.repeatCount && parseInt(blockObj.repeatCount) <= 0) ? 1 : parseInt(blockObj.repeatCount);
				facilityInfo = that.getFacilityData(blockObj.facilityName, blockObj.category, facilityList);
				if (facilityInfo) {
					holidays = that.createHolidays(blockObj, facilityInfo);
					if (holidays.length > 0) {
						facilityData.push({
							facilityId: facilityInfo.facilityId,
							name: facilityInfo.name,
							timings: facilityInfo.timings,
							timezoneOffset: facilityInfo.timezoneOffset,
							holidays: holidays,
						});
					}
				}

			});
		}
		let reqObj = {
			'vendorId': vendorId,
			'facilityData': facilityData ? facilityData : []
		}
		console.log('facilityData', facilityData);
		return facilityData;
	}

	getFacilityList(): Array<any> {
		let that = this;
		let facilityList = [];
		let facilityData = [];
		if (localStorage.getItem('vendor_facilityData')) {
			facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
		}
		facilityData.forEach(data => {
			data.data.forEach(facility => {
				facilityList.push(facility);
			});
		});
		return facilityList;
	}

	getFacilityData(facilityName: string, category, facilityList: Array<any>): any {
		const facilityObj = _.find(facilityList, function (rec: any) {
			return rec.name.toLowerCase() == facilityName.toLowerCase() && rec.category.toLowerCase() == category.toLowerCase();
		});
		return facilityObj ? { name: facilityObj.name, facilityId: facilityObj._id, timings: facilityObj.timings, timezoneOffset: facilityObj.timezoneOffset, unitNames: facilityObj.unitNames, holidays: facilityObj.holidays } : '';
	}

	createHolidays(blockObj: any, facilityInfo: any): any {
		let holidays = [];
		let blockEndDate = new Date(blockObj.endDate);
		let blockStartDate = new Date(blockObj.startDate);
		blockStartDate.setHours(0, 0, 0, 0);
		blockEndDate.setHours(23, 59, 0, 0);
		if (blockStartDate.getTime() <= blockEndDate.getTime()) {

			let d = _.cloneDeep(blockStartDate);
			let slotObj;
			let momentDateFormat;
			let i = 0;
			while (i < blockObj.repeatCount) {

				if (d < blockStartDate) {
					d = _.cloneDeep(blockStartDate);
				}
				for (; d <= blockEndDate; d.setDate(d.getDate() + 1)) {
					slotObj = {
						'start': blockObj.startTime + ':00:00',
						'end': blockObj.endTime + ':00:00',
						'note': ''
					}
					momentDateFormat = moment(d).format('DD/MM/YYYY');
					let holidayObj = {
						isFullDay: blockObj.isEntireDay,
						date: momentDateFormat,
						unitNames: blockObj.unitName.toLowerCase() === 'all' ? facilityInfo.unitNames : [blockObj.unitName],
						isUnitBlock: true,
						slots: blockObj.isEntireDay ? [] : [
							slotObj
						],
					}
					if (this.checkWithExistingHolidays(holidayObj, facilityInfo.holidays)) {
						holidays.push(holidayObj);
					}

				}
				blockStartDate.setDate(blockStartDate.getDate() + 7);
				blockEndDate.setDate(blockEndDate.getDate() + 7);
				i++;
			}
		}
		return holidays;
	}
	checkWithExistingHolidays(holidayObj, existingHolidays) {
		let obt = _.find(existingHolidays, holidayObj)
		console.log(obt);
		if (_.find(existingHolidays, holidayObj)) {
			return false;
		} else {
			return true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/blockSlots.ts